/* eslint-disable complexity */
import React from "react"
import { useTranslation } from "react-i18next"

import { ButtonLink } from "~/components/Button/Button"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

type Props = {
  linkButton: string
  requestMeeting: string
  buttonLink: string
  buttonName: string
}

export const ButtonsWrapper: React.FC<Props> = ({
  linkButton,
  requestMeeting,
  buttonLink,
  buttonName,
}) => {
  const { t } = useTranslation()

  if (!linkButton && !requestMeeting && !buttonLink && !buttonName) {
    return null
  }

  return (
    <div className={styles.Wrapper}>
      {linkButton && (
        <ButtonLink className={styles.Button} href={linkButton} view="xl">
          <Raw html={t("event.Buttons.Appointment")} />
        </ButtonLink>
      )}

      {requestMeeting && (
        <ButtonLink className={styles.Button} href={requestMeeting} view="outline">
          <Raw html={t("event.Buttons.Request")} />
        </ButtonLink>
      )}

      {buttonLink && buttonName && (
        <ButtonLink className={styles.Button} href={buttonLink} view="outline">
          <Raw html={buttonName} />
        </ButtonLink>
      )}
    </div>
  )
}
